import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router';
import { gtagService } from '../../services/gtag';

const ScrollToTop = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    // Track page view (only if no hash, to avoid duplicate tracking).
    // OpenPanel screen views + UTM globals are handled by the SDK itself.
    if (!location.hash) {
      gtagService.trackPageView(location.pathname + location.search);
    }

    // Don't scroll to top if there's a hash in the URL (let hash navigation handle it)
    if (location.hash) {
      return;
    }

    // Scroll to top whenever the route changes
    // Use setTimeout to ensure DOM is fully rendered
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto'
      });
      // Fallback for older browsers
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    // Small delay to ensure page is rendered
    const timeoutId = setTimeout(scrollToTop, 0);
    
    return () => clearTimeout(timeoutId);
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default ScrollToTop; 